import {
  VISIBILITY,
  checkIfSelectionValid,
} from '@learningblocks/protocol-constants/lib/Utilities';
const NEXT_COMPONENT = 'nextComponent';

// check if selected Question option correct adn update accordingly
export function submitQuestionAnswer(state, payload) {
  return {
    ...state,
    currentSection: updateSubmissionInCurrentSection(
      state.currentSection,
      payload
    ),
  };
}

function updateSubmissionInCurrentSection(currentSection, payload) {
  return {
    ...currentSection,
    components: updateSubmissionInComponents(
      currentSection.components,
      payload
    ),
  };
}

function updateSubmissionInComponents(components, payload) {
  const {newcomponents} = components.reduce(
    (acc, component) => {
      // updating submitted MSCQ component
      if (component.id === payload.componentID) {
        component = updateMSCQComponent(component);
        if (component.hasOwnProperty(NEXT_COMPONENT)) {
          acc.forward = {
            complete: component.complete,
            nextComponent: component.nextComponent,
          };
        }
      }

      // updating forward component and setting its visibility
      if (
        acc.forward &&
        acc.forward.complete &&
        acc.forward.nextComponent === component.id
      ) {
        component = {...component, visibility: VISIBILITY.VISIBLE};
        acc.forward = null;
      }

      acc.newcomponents = [...acc.newcomponents, component];
      return acc;
    },
    {
      forward: null,
      newcomponents: [],
    }
  );
  return newcomponents;
}

function updateMSCQComponent(component) {
  if (checkIfSelectionValid(component)) {
    component.checkboxes = component.checkboxes.map(updateSelectedCheckbox);
    component.complete = updateMSCQComplete(
      component.checkboxes,
      component.answerId
    );
    if (component.totalAttempts !== -10) {
      component.totalAttempts -= 1;
    }
  }
  return component;
}

function updateSelectedCheckbox(checkboxOption) {
  if (checkboxOption.selected === true) {
    checkboxOption.disabled = true;
  }
  return {...checkboxOption};
}

const updateMSCQComplete = (checkboxes, answerId) => {
  const selectedCheckboxes = checkboxes.reduce((selected, option) => {
    if (option.selected) {
      selected.push(option.id);
    }
    return selected;
  }, []);
  for (let id in answerId) {
    if (selectedCheckboxes.includes(id) === false) {
      return false;
    }
  }
  return true;
};
